export default __webpack_public_path__ + "static/media/webinaire_2.883014f7.jpg";